import * as util from "@/util";
import Router from "vue-router";

/**
 * Append gtag script to DOM
 * @param  {String} trackId GA_TRACKING_ID
 * @param  {String} id      script id
 */
function appendGtagScript(trackId: string, scriptTagID: string) {
  const s = document.createElement("script");
  s.id = scriptTagID;
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${trackId}`;
  let n = document.getElementsByTagName("head")[0];
  if (!n) {
    n = document.body;
  }
  n.appendChild(s);
}

interface GWindow extends Window {
  dataLayer?: unknown[];
  gtag?: { (...args: unknown[]): void };
}
function getGWindow() {
  return window as unknown as GWindow;
}

/**
 * initialize gtag
 * @param  {String} trackId GA_TRACKING_ID
 * @param  {Object} opts  {debug,scriptId}
 */
function initialize(trackId: string, opts: Options) {
  const w = getGWindow();
  if (w.gtag) {
    return;
  }
  appendGtagScript(trackId, opts.scriptId || "gtagjs");
  w.dataLayer = w.dataLayer || [];
  const gtag = (w.gtag = w.gtag || pushDataLayer);
  const gtagOpt = opts.gtagOpt || {};
  gtag("js", new Date());
  gtag("config", trackId, gtagOpt);
}

function pushDataLayer(...args: unknown[]) {
  const w = getGWindow();
  if (w && w.dataLayer) {
    w.dataLayer.push(args);
  }
}

/**
 * set page path and send page_view event
 * @param  {String} pathPath
 * @param  {String} trackId GA_TRACKING_ID
 * @param  {Object} opts
 */
function configPagePath(pathPath: string, trackId: string, opts: Options) {
  initialize(trackId, opts);
  const w = getGWindow();
  if (w.gtag) {
    w.gtag("config", trackId, { page_path: pathPath });
  }
}

function log(message: string) {
  util.log("Analytics " + message);
}

type OnRouteChangeFunc = (url: string) => void;
type RouteFunc = (f: OnRouteChangeFunc) => void;

interface Options {
  debug?: boolean;
  scriptId?: string;
  gtagOpt?: unknown;
}

/**
 * Configure the gtag route
 * @param  {Router | RouteFunc} router Vue Router or a function that receives the handler to report route changes
 * @param  {String} trackId GA_TRACKING_ID
 * @param  {Object} opts
 */
export default function (router: Router | RouteFunc, trackId: string, opts: Options = {}) {
  //lIsDebug = !!opts.debug;
  if (typeof router === "function") {
    router((url) => {
      configPagePath(url, trackId, opts);
      log(`new page: ${url}`);
    });
  } else {
    router.afterEach((to) => {
      configPagePath(to.fullPath, trackId, opts);
      log(`new page: ${to.fullPath}`);
    });
  }
}

export function setUserID(userID: string) {
  const w = getGWindow();
  if (w.gtag) {
    w.gtag("set", { user_id: userID });
    log("user-id: " + (userID || "null"));
  }
}
